<template>
  <div>
    <typing-note-print
      :generalConfig="generalConfig"
      :integratedTestConfig="integratedTest"
      :print="print.note"
      :featureFlags="featureFlags"
    />
  </div>
</template>

<script>
import TypingNotePrint from '@/components/Print/TypingNotePrint.vue';
import configService from '@/services/config.service';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'TypingNote',
  components: {
    TypingNotePrint,
  },
  computed: {
    ...mapState('note', ['print']),
    ...mapGetters('config', ['general', 'integratedTest', 'featureFlags', 'all']),
    isCurrentClinicNote() {
      // Check whether the note's clinic is the same as current config (current selected clinic in top-right dropdown)
      return this.all.clinic === this.print.clinicId;
    },
    generalConfig() {
      if (!this.isCurrentClinicNote) {
        return this.clinicConfig.general || {};
      }
      return this.general;
    },
  },
  data() {
    return {
      clinicConfig: {},
    };
  },
  async created() {
    if (!this.isCurrentClinicNote) {
      const res = await configService.show(this.print.clinicId);
      this.clinicConfig = res.data || {};
    }
  },
};
</script>
